import { gql } from '@apollo/client'

const lotParkingMethods = gql`
  query lotParkingMethods($id: Int!) {
    lotParkingMethods(lotId: $id) {
      event {
        active
        downloadLink
      }
      onDemand {
        active
        downloadLink
      }
      subscription {
        active
        downloadLink
      }
    }
  }
`

export default lotParkingMethods
